import { Skeleton } from '@/components/ui/skeleton';
import { VStack } from '@chakra-ui/react';

const LoaderSkeleton = () => {
  return (
    <VStack w='full' gap={4} alignItems='stretch' px='4'>
      <Skeleton w={'full'} h={'124px'} rounded='2xl' bg='#dcdcd9' />
      <Skeleton w={'full'} h={'124px'} rounded='2xl' bg='#dcdcd9' />
      <Skeleton w={'full'} h={'124px'} rounded='2xl' bg='#dcdcd9' />
      <Skeleton w={'full'} h={'124px'} rounded='2xl' bg='#dcdcd9' />
    </VStack>
  );
};

export default LoaderSkeleton;
